/**
 * Contrast pairings for brio's semantic tokens -- the single source of
 * truth for both the docs table (src/docs/docs-contrast.js) and the CI
 * token check (scripts/check-contrast.mjs), so the two can't drift.
 *
 * Each pairing: { fg, bg, label, min?, note? }
 *
 * min -- WCAG threshold for the pairing: 4.5 for text (AA normal),
 * 3 for non-text UI (WCAG 1.4.11). Defaults to 4.5.
 */
export const PAIRINGS = [
    { fg: '--color-text', bg: '--color-surface', label: 'text / surface' },
    { fg: '--color-text', bg: '--color-surface-raised', label: 'text / raised' },
    { fg: '--color-text', bg: '--color-surface-sunken', label: 'text / sunken' },
    { fg: '--color-text-muted', bg: '--color-surface', label: 'muted / surface' },
    { fg: '--color-text-muted', bg: '--color-fill', label: 'muted / fill (neutral badge)' },
    {
        fg: '--color-text-subtle',
        bg: '--color-surface',
        label: 'subtle / surface',
        note: 'By design -- use for large text or decorative elements only',
    },
    { fg: '--color-on-primary', bg: '--color-primary', label: 'on-primary / primary' },
    { fg: '--color-on-accent', bg: '--color-accent', label: 'on-accent / accent' },
    { fg: '--color-on-danger', bg: '--color-danger', label: 'on-danger / danger' },
    { fg: '--color-on-success', bg: '--color-success', label: 'on-success / success' },
    { fg: '--color-on-warning', bg: '--color-warning', label: 'on-warning / warning' },
    { fg: '--color-link', bg: '--color-surface', label: 'link / surface' },
    { fg: '--color-link-visited', bg: '--color-surface', label: 'link-visited / surface' },
    {
        fg: '--color-on-primary-subtle',
        bg: '--color-primary-subtle',
        label: 'on-primary-subtle / primary-subtle',
    },
    {
        fg: '--color-on-accent-subtle',
        bg: '--color-accent-subtle',
        label: 'on-accent-subtle / accent-subtle',
    },
    {
        fg: '--color-on-danger-subtle',
        bg: '--color-danger-subtle',
        label: 'on-danger-subtle / danger-subtle',
    },
    {
        fg: '--color-on-success-subtle',
        bg: '--color-success-subtle',
        label: 'on-success-subtle / success-subtle',
    },
    {
        fg: '--color-on-warning-subtle',
        bg: '--color-warning-subtle',
        label: 'on-warning-subtle / warning-subtle',
    },
    { fg: '--color-primary-text', bg: '--color-surface', label: 'primary text / surface' },
    { fg: '--color-accent-text', bg: '--color-surface', label: 'accent text / surface' },
    { fg: '--color-danger-text', bg: '--color-surface', label: 'danger text / surface' },
    { fg: '--color-success-text', bg: '--color-surface', label: 'success text / surface' },
    { fg: '--color-warning-text', bg: '--color-surface', label: 'warning text / surface' },
    {
        fg: '--color-selection-text',
        bg: '--color-selection-bg',
        label: 'selection text / selection bg',
    },
    {
        fg: '--color-focus',
        bg: '--color-surface',
        label: 'focus ring / surface',
        min: 3,
        note: 'Non-text contrast (WCAG 1.4.11): 3:1',
    },
    {
        fg: '--color-on-primary-soft',
        bg: '--color-primary-soft',
        label: 'on-primary-soft / primary-soft',
    },
    {
        fg: '--color-on-accent-soft',
        bg: '--color-accent-soft',
        label: 'on-accent-soft / accent-soft',
    },
    {
        fg: '--color-on-danger-soft',
        bg: '--color-danger-soft',
        label: 'on-danger-soft / danger-soft',
    },
    {
        fg: '--color-on-success-soft',
        bg: '--color-success-soft',
        label: 'on-success-soft / success-soft',
    },
    {
        fg: '--color-on-warning-soft',
        bg: '--color-warning-soft',
        label: 'on-warning-soft / warning-soft',
    },
];
